import cx from 'classnames';
import NextLink from 'next/link';

import {Icon, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {HeaderItemProps} from './HeaderItem.types';

import * as css from './HeaderItem.css';

const getTextVariantForHeaderVariant = (variant: HeaderItemProps['variant']) => {
  switch (variant) {
    case 'mobile':
      return 'heading2';
    case 'mobileFooter':
      return 'buttonSmall';
    case 'dark':
    case 'light':
    case 'crimson':
    default:
      return 'button';
  }
};

// The variant here is the variant of the header background, not the variant of the item
const getLockedVariant = (variant: HeaderItemProps['variant']) => {
  switch (variant) {
    case 'light':
      return 'darkLocked';
    case 'mobile':
    case 'mobileFooter':
    case 'dark':
    case 'crimson':
    default:
      return 'lightLocked';
  }
};

export const HeaderItem = ({
  children,
  className,
  href,
  variant = 'light',
  locked = false,
  ...otherProps
}: HeaderItemProps) => {
  if (locked) {
    delete otherProps.onClick;
  }
  const menuItem = (
    <Text
      as={href ? 'a' : 'button'}
      className={cx(css.root({variant: locked ? getLockedVariant(variant) : variant}), className)}
      textAlign="left"
      variant={getTextVariantForHeaderVariant(variant)}
      {...otherProps}>
      {locked && <Icon name="Lock" color="currentColor" className={sprinkles({pL: 0})} />}
      {children}
    </Text>
  );

  return href && !locked ? (
    <NextLink href={href} passHref>
      {menuItem}
    </NextLink>
  ) : (
    menuItem
  );
};
